import { Box, Typography } from "@mui/material"
import type { ReactElement } from "react"
import React from "react"

import { type AerosTagData, AerosTagStack } from "@/components/UiKit"

const SelectedItemsArea = ({
  items,
  onDelete,
  title = "Selected Items",
}: {
  items: AerosTagData[]
  onDelete: (tagToDelete: AerosTagData) => void
  title: string
}): ReactElement => {
  return (
    <Box className='mb-5 rounded-md border border-gray-400 p-6'>
      <Typography className='mb-5 text-ml text-gray-900'>{title}</Typography>
      <Box className='rounded-s border border-gray-400 px-4 py-3'>
        <AerosTagStack tags={items} onDelete={onDelete} shouldWrap={true} />
      </Box>
    </Box>
  )
}

export default SelectedItemsArea
